"use strict";

window.addEventListener("DOMContentLoaded", init);
window.addEventListener("resize", update);

function init() {
	setCssVariables();
	tabUI();
}

function update() {
	setCssVariables();
}

function getHeaderHeight() {
	return document.querySelector('.header').offsetHeight;
}

function setCssVariables() {
	document.documentElement.style.setProperty('--header-height', getHeaderHeight() + 'px');
}


function tabUI() {
	const tabs = document.querySelectorAll('.js-tab');
	const panels = document.querySelectorAll('.js-panel');

	tabs.forEach(tab => {
		tab.addEventListener('click', () => {
			const target = tab.getAttribute('data-tab-target');

			tabs.forEach(tab => {
				tab.classList.remove('is-active');
			});

			panels.forEach(panel => {
				panel.classList.remove('is-active');
			});

			tab.classList.add('is-active');
			document.querySelector(`#${target}`).classList.add('is-active');
		});
	});
}
